import { ChainNamespaceType, CustomChainConfig } from '@web3auth/base'
import { toHex } from 'viem'
import blockchainConfig from './blockchain'

interface NativeCurrency {
  name: string
  symbol: string
  decimals: number
}

export interface MetamaskChainConfig {
  chainId: string
  chainName: string
  nativeCurrency: NativeCurrency
  rpcUrls: string[]
  blockExplorerUrl?: string[]
  iconUrls?: string[]
}

// interface WagmiChainConfig extends Omit<Omit<MetamaskChainConfig, 'rpcUrls'>, 'nativeCurrency'> {
interface WagmiChainConfig {
  name: string
  network: string
  id: number
  rpcUrls: {
    public: {
      http: string[]
    }
    default: {
      http: string[]
    }
  }
  blockExplorers: {
    default: {
      name: string
      url: string
    }
  }
  nativeCurrency: NativeCurrency
}

export interface Web3AuthChainConfig extends CustomChainConfig {}

/* -------------------------------------------------------------------------- */
/*                       General Network Configurations                       */
/* -------------------------------------------------------------------------- */
export const l1NativeConfig = {
  name: blockchainConfig.NATIVE_CHAIN_NAME,
  network: blockchainConfig.NATIVE_CHAIN_NAME.toLocaleLowerCase().replace(' ', '_'),
  chainId: blockchainConfig.NATIVE_CHAIN_ID || 7649,
  chainIdHex: toHex(blockchainConfig.NATIVE_CHAIN_ID || 7649),
  nativeCurrency: {
    name: 'Lamina',
    symbol: blockchainConfig.NATIVE_CHAIN_TICKER || 'L1',
    decimals: 18,
  },
  chainNamespace: 'eip155',
  rpcUrl: blockchainConfig.NATIVE_CHAIN_RPC,
  blockExplorerUrl: blockchainConfig.EXPLORER_URL,
}

export const l1IdSubnetConfig = {
  name: blockchainConfig.IDENTITY_SUBNET_NAME,
  network: blockchainConfig.IDENTITY_SUBNET_NAME.toLocaleLowerCase().replace(' ', '_'),
  chainId: blockchainConfig.IDENTITY_SUBNET_ID || 12345,
  chainIdHex: toHex(blockchainConfig.IDENTITY_SUBNET_ID || 12345),
  nativeCurrency: {
    name: 'L1Identity',
    symbol: blockchainConfig.IDENTITY_SUBNET_TICKER || 'L1ID',
    decimals: 18,
  },
  chainNamespace: 'eip155',
  rpcUrl: blockchainConfig.IDENTITY_SUBNET_RPC,
  blockExplorerUrl: blockchainConfig.EXPLORER_URL,
}

/* -------------------------------------------------------------------------- */
/*                            Metamask Chain Config                           */
/* -------------------------------------------------------------------------- */
export const l1NativeMetamaskConfig: MetamaskChainConfig = {
  chainId: l1NativeConfig.chainIdHex,
  chainName: l1NativeConfig.name,
  nativeCurrency: l1NativeConfig.nativeCurrency,
  rpcUrls: [l1NativeConfig.rpcUrl],
  // blockExplorerUrl: [l1NativeConfig.blockExplorerUrl],
  iconUrls: [],
}

export const l1IdSubnetMetamaskConfig: MetamaskChainConfig = {
  chainId: l1IdSubnetConfig.chainIdHex,
  chainName: l1IdSubnetConfig.name,
  nativeCurrency: l1IdSubnetConfig.nativeCurrency,
  rpcUrls: [l1IdSubnetConfig.rpcUrl],
  // blockExplorerUrl: [l1IdSubnetConfig.blockExplorerUrl],
  iconUrls: [],
}

const { rpcUrls, nativeCurrency, ...l1NativeMetamaskConfigWithoutElements } = l1NativeMetamaskConfig
const {
  rpcUrls: rpcUrls2,
  nativeCurrency: nativeCurrency2,
  ...l1IdSubnetMetamaskConfigWithoutElements
} = l1IdSubnetMetamaskConfig

/* -------------------------------------------------------------------------- */
/*                            Web3Auth Chain Config                           */
/* -------------------------------------------------------------------------- */
export const l1NativeWeb3AuthConfig: Web3AuthChainConfig = {
  displayName: l1NativeConfig.name,
  chainId: l1NativeConfig.chainIdHex,
  chainNamespace: l1NativeConfig.chainNamespace as ChainNamespaceType,
  rpcTarget: l1NativeConfig.rpcUrl,
  blockExplorer: l1NativeConfig.blockExplorerUrl,
  ticker: l1NativeConfig.nativeCurrency.symbol,
  tickerName: l1NativeConfig.nativeCurrency.name,
  decimals: l1NativeConfig.nativeCurrency.decimals,
}

export const l1IdSubnetWeb3AuthConfig: Web3AuthChainConfig = {
  displayName: l1IdSubnetConfig.name,
  chainId: l1IdSubnetConfig.chainIdHex,
  chainNamespace: l1IdSubnetConfig.chainNamespace as ChainNamespaceType,
  rpcTarget: l1IdSubnetConfig.rpcUrl,
  blockExplorer: l1IdSubnetConfig.blockExplorerUrl,
  ticker: l1IdSubnetConfig.nativeCurrency.symbol,
  tickerName: l1IdSubnetConfig.nativeCurrency.name,
  decimals: l1IdSubnetConfig.nativeCurrency.decimals,
}

/* -------------------------------------------------------------------------- */
/*                             Wagmi Chain Config                             */
/* -------------------------------------------------------------------------- */
export const l1NativeWagmiConfig: WagmiChainConfig = {
  name: l1NativeConfig.name,
  network: l1NativeConfig.network,
  id: l1NativeConfig.chainId,
  rpcUrls: {
    public: {
      http: [l1NativeConfig.rpcUrl],
    },
    default: {
      http: [l1NativeConfig.rpcUrl],
    },
  },
  blockExplorers: {
    default: {
      name: 'Lamina1 Explorer',
      url: l1NativeConfig.blockExplorerUrl,
    },
  },
  nativeCurrency: l1NativeConfig.nativeCurrency,
  // ...l1NativeMetamaskConfigWithoutElements,
}

export const l1IdSubnetWagmiConfig: WagmiChainConfig = {
  name: l1IdSubnetConfig.name,
  network: l1IdSubnetConfig.network,
  id: l1IdSubnetConfig.chainId,
  rpcUrls: {
    public: {
      http: [l1IdSubnetConfig.rpcUrl],
    },
    default: {
      http: [l1IdSubnetConfig.rpcUrl],
    },
  },
  blockExplorers: {
    default: {
      name: 'Lamina1 Explorer',
      url: l1IdSubnetConfig.blockExplorerUrl,
    },
  },
  nativeCurrency: l1IdSubnetConfig.nativeCurrency,
  // ...l1IdSubnetMetamaskConfigWithoutElements,
}
